import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { GenericInputFieldComponent } from '../../../shared/components/generic-input-field/generic-input-field.component';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../shared/services/auth.service';
import { GenericService } from '../../../shared/services/generic.services/generic.service';
import { IAuthData, LoginModel } from '../../../shared/models/loginViewModel';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    GenericInputFieldComponent,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    RouterModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {
  loginForm = this.fb.group({
    UserName: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required]],
  });

  constructor(
    private fb: FormBuilder,
    private gen: GenericService,
    private router: Router,
    public authService: AuthService,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef
  ) {
    // const currentUser = this.authService.currentUser as IAuthData;
    // if (currentUser) {
    //   this.router.navigate(['/bms' + authService.currentUser.index]);
    // }
  }

  ngOnInit(): void {}

  get f() {
    return this.loginForm.controls;
  }

  signIn(): void {
    if (this.loginForm.invalid) return;
    this.gen.showLoader('Signing in');
    this.authService.login(this.loginForm.value as LoginModel).subscribe({
      next: (res) => {
        if (res.statusCode === 200) {
          const authData: IAuthData = res.value;
          if (!authData.token) return;
          this.authService.setUser(authData);
          // const returnUrl = this.route.snapshot.queryParams['returnUrl'];
          this.router.navigate(['/bms' + authData.index]);
        } else {
          this.gen.showMessage('error', res.value);
        }
        this.gen.hideLoader();
        this.cd.markForCheck();
      },
      error: (err) => {
        this.gen.hideLoader();
        console.log(err);
        this.gen.showMessage('error', 'Invalid username or password.');
      },
    });
  }
}
